var path = '/opt/atlassian/pipelines/agent/build/src/app/components/home/home.html';
var html = "<section class=dashboard-content> <div class=row> <div class=\"col-md-12 no-padding\"> <div class=row> <div class=\"no-padding outer-feature-div col-md-4 col-sm-6 col-xs-6 col-lg-4\" ng-repeat=\"feature in $ctrl.features\"> <div ng-click=$ctrl.onClick(feature.route.name) class=main-feature-div> <div class=inner-feature-div> <div class=home-feature-image> <div class=icon-dashboard ng-class=feature.iconName></div> </div> <div class=home-feature-caption> <h4>{{feature.displayName}}</h4> </div> </div> </div> </div> </div> </div> </div> </section> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/components/home/home.html
// module id = 954
// module chunks = 0